import { useState } from "react";
import axios from "../../../../../axios";

const UnblockScreen = ({
  clickedAction,
  setShowUnblock,
  assesmentId,
  fetchStudentData,
}) => {
  const [blocked, setBlocked] = useState(true);
  const [duration, setDuration] = useState("");
  const [endTime, setEndTime] = useState(null);
  const [toalDurationCheck, setTotalDurationCheck] = useState(false);

  function formatDateTime(dateTimeString) {
    if (!dateTimeString) return null;
    const date = new Date(dateTimeString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const paddedDay = day < 10 ? "0" + day : day;
    const paddedMonth = month < 10 ? "0" + month : month;
    const paddedHours = hours < 10 ? "0" + hours : hours;
    const paddedMinutes = minutes < 10 ? "0" + minutes : minutes;
    return `${paddedDay}-${paddedMonth}-${year} ${paddedHours}:${paddedMinutes} ${ampm}`;
  }

  function convertTime(inputTime) {
    try {
      const [hours, minutes] = inputTime?.split(":");
      const timeParts = inputTime?.split(" ");
      const ampm = timeParts[1];
      const hoursNum = parseInt(hours, 10);
      const minutesNum = parseInt(minutes, 10);

      const utcDate = new Date();
      utcDate.setUTCHours(hoursNum, minutesNum, 0, 0);
      const istDate = new Date(utcDate.getTime());

      let istHours = istDate.getHours();
      const istMinutes = istDate.getMinutes();

      const formattedHoursStr = String(istHours).padStart(2, "0");
      const formattedMinutesStr = String(istMinutes).padStart(2, "0");

      return `${formattedHoursStr}:${formattedMinutesStr} ${ampm}`;
    } catch (error) {
      console.error("Error converting time:", error);
      return "";
    }
  }

  function parseTime(timeString) {
    if (!timeString) return null;
    const [time, period] = timeString.split(" ");
    const [hour, minute] = time.split(":").map((num) => parseInt(num));
    let hours = hour;
    if (period === "PM" && hour !== 12) hours += 12;
    else if (period === "AM" && hour === 12) hours = 0;
    return { hours, minutes: minute };
  }

  function calculateTimeDifference(time1, time2) {
    if (time1 && time2) {
      const t1 = parseTime(time1);
      const t2 = parseTime(time2);
      const totalMinutes1 = t1.hours * 60 + t1.minutes;
      const totalMinutes2 = t2.hours * 60 + t2.minutes;
      let difference = totalMinutes2 - totalMinutes1;
      if (difference < 0) difference += 24 * 60;
      return difference;
    }
  }

  const handleAssesmentUnblock = async () => {
    try {
      let res = await axios.put(
        `api/v1/assessment/UpdateStartedFlag/assessmentId/${assesmentId}/studentId/${clickedAction?.student_id?.id}`,
        {
          started_flag: "false",
          currentStatus: "Not Started",
          resetDuration: parseInt(duration),
          newEndTime: endTime,
          unblockCount: true,
        },
      );
      if (res) {
        setShowUnblock(false);
        fetchStudentData();
      }
    } catch (error) {}
  };

  const canUnblock = !!(endTime && duration) && !toalDurationCheck;

  return (
    <>
      <style>{`
        .ubs-backdrop {
          position: fixed; inset: 0;
          background: rgba(15, 23, 42, 0.55);
          backdrop-filter: blur(3px);
          display: flex; align-items: center; justify-content: center;
          z-index: 1500; padding: 16px;
          animation: ubs-fade .15s ease-out;
        }
        .ubs-card {
          width: min(760px, 96vw);
          max-height: 92vh;
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 24px 60px rgba(0,0,0,0.28);
          display: flex; flex-direction: column;
          overflow: hidden;
          animation: ubs-pop .18s ease-out;
        }
        .ubs-header {
          padding: 16px 22px;
          background: linear-gradient(135deg, #fef2f2 0%, #fff1f2 100%);
          border-bottom: 1px solid #fee2e2;
          display: flex; align-items: center; gap: 12px;
        }
        .ubs-header-icon {
          width: 40px; height: 40px; border-radius: 50%;
          background: #fff;
          display: flex; align-items: center; justify-content: center;
          box-shadow: 0 2px 8px rgba(220,38,38,.14);
          flex-shrink: 0;
        }
        .ubs-header-title {
          font-size: 15px; font-weight: 700; color: #7f1d1d;
          margin: 0; line-height: 1.2;
        }
        .ubs-header-sub {
          font-size: 12px; color: #991b1b; margin-top: 2px;
        }
        .ubs-body {
          padding: 20px 22px;
          overflow-y: auto;
          flex: 1;
        }
        .ubs-section {
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          padding: 16px;
          margin-bottom: 16px;
          background: #f9fafb;
        }
        .ubs-section.white { background: #fff; }
        .ubs-section.blue {
          background: #eff6ff;
          border-color: #bfdbfe;
        }
        .ubs-section-title {
          font-size: 11px; font-weight: 700; color: #6b7280;
          text-transform: uppercase; letter-spacing: 0.5px;
          margin: 0 0 12px 0;
        }
        .ubs-info-row {
          display: flex; justify-content: space-between; align-items: center;
          padding: 6px 0;
          font-size: 13px;
        }
        .ubs-info-label { color: #6b7280; font-size: 12px; }
        .ubs-info-value { color: #111827; font-weight: 600; font-size: 13px; }
        .ubs-student-head {
          display: flex; justify-content: space-between; align-items: center;
          flex-wrap: wrap; gap: 8px; margin-bottom: 14px;
        }
        .ubs-student-name {
          font-size: 15px; font-weight: 700; color: #111827; margin: 0;
        }
        .ubs-chips { display: flex; gap: 8px; align-items: center; }
        .ubs-chip {
          font-size: 10px; font-weight: 700; padding: 3px 10px;
          border-radius: 999px; text-transform: uppercase;
          letter-spacing: 0.4px; line-height: 1.4;
        }
        .ubs-chip.red { background: #fee2e2; color: #b91c1c; }
        .ubs-chip.amber { background: #fef3c7; color: #b45309; }
        .ubs-attempt-table {
          width: 100%; border-collapse: collapse; font-size: 12px;
        }
        .ubs-attempt-table th {
          font-size: 10px; font-weight: 700; text-transform: uppercase;
          letter-spacing: 0.3px; color: #6b7280; text-align: left;
          padding: 8px 10px; border-bottom: 1px solid #e5e7eb;
        }
        .ubs-attempt-table td {
          padding: 8px 10px; color: #374151;
          border-bottom: 1px solid #f3f4f6;
        }
        .ubs-attempt-table tr:last-child td { border-bottom: none; }
        .ubs-badge {
          display: inline-flex; align-items: center; justify-content: center;
          width: 20px; height: 20px; border-radius: 50%;
          background: #eef2ff; color: #1d4ed8;
          font-size: 10px; font-weight: 700;
        }
        .ubs-empty {
          font-size: 12px; color: #9ca3af; font-style: italic;
          padding: 6px 0;
        }
        .ubs-form-row {
          display: flex; gap: 16px; flex-wrap: wrap;
        }
        .ubs-field {
          flex: 1 1 220px; min-width: 200px;
        }
        .ubs-label {
          font-size: 11px; font-weight: 600; color: #374151;
          display: block; margin-bottom: 6px;
        }
        .ubs-input {
          width: 100%; height: 38px; padding: 0 12px;
          font-size: 13px; color: #111827;
          border: 1px solid #bfdbfe; border-radius: 8px;
          background: #fff; outline: none;
          transition: all .15s; font-family: inherit;
        }
        .ubs-input:hover { border-color: #93c5fd; }
        .ubs-input:focus { border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37,99,235,.12); }
        .ubs-input-wrap { position: relative; }
        .ubs-input-suffix {
          position: absolute; right: 12px; top: 50%;
          transform: translateY(-50%);
          font-size: 11px; color: #9ca3af; pointer-events: none;
        }
        .ubs-warn {
          margin-top: 10px; font-size: 11px; color: #dc2626;
          display: flex; align-items: center; gap: 6px;
        }
        .ubs-footer {
          padding: 14px 22px;
          border-top: 1px solid #e5e7eb;
          background: #fafafa;
          display: flex; justify-content: flex-end; gap: 10px;
        }
        .ubs-btn {
          padding: 9px 22px; font-size: 13px; font-weight: 600;
          border-radius: 8px; cursor: pointer;
          transition: all .15s; font-family: inherit;
          display: inline-flex; align-items: center; gap: 8px;
        }
        .ubs-btn:disabled { cursor: not-allowed; }
        .ubs-btn-cancel {
          background: #fff; color: #374151;
          border: 1px solid #e5e7eb;
        }
        .ubs-btn-cancel:hover {
          border-color: #d1d5db; background: #f9fafb;
        }
        .ubs-btn-unblock {
          background: linear-gradient(135deg, #dc2626, #b91c1c);
          color: #fff; border: none;
          box-shadow: 0 3px 10px rgba(220,38,38,.25);
        }
        .ubs-btn-unblock:hover:not(:disabled) {
          background: linear-gradient(135deg, #b91c1c, #991b1b);
          box-shadow: 0 5px 14px rgba(220,38,38,.35);
        }
        .ubs-btn-unblock:disabled {
          background: #e5e7eb; color: #9ca3af; box-shadow: none;
        }
        @keyframes ubs-fade { from { opacity: 0 } to { opacity: 1 } }
        @keyframes ubs-pop {
          from { opacity: 0; transform: translateY(6px) scale(.98) }
          to { opacity: 1; transform: translateY(0) scale(1) }
        }
      `}</style>

      <div className="ubs-backdrop" onClick={() => setShowUnblock(false)}>
        <div className="ubs-card" onClick={(e) => e.stopPropagation()}>
          {/* HEADER */}
          <div className="ubs-header">
            <div className="ubs-header-icon">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#dc2626"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
              </svg>
            </div>
            <div>
              <h3 className="ubs-header-title">Student Blocked</h3>
              <div className="ubs-header-sub">
                Unblock this student to allow re-attempt
              </div>
            </div>
          </div>

          {/* BODY */}
          <div className="ubs-body">
            {/* Assessment info */}
            <div className="ubs-section">
              <p className="ubs-section-title">Assessment Details</p>
              <div className="ubs-info-row">
                <span className="ubs-info-label">Assessment</span>
                <span className="ubs-info-value">
                  {clickedAction?.assessment_id?.name || "—"}
                </span>
              </div>
              <div className="ubs-info-row">
                <span className="ubs-info-label">Subject</span>
                <span className="ubs-info-value">
                  {clickedAction?.assessment_id?.subject?.name || "—"}
                </span>
              </div>
              <div className="ubs-info-row">
                <span className="ubs-info-label">Deadline</span>
                <span className="ubs-info-value">
                  {formatDateTime(clickedAction?.assessment_id?.deadline) ||
                    "—"}
                </span>
              </div>
              <div className="ubs-info-row">
                <span className="ubs-info-label">Total Duration</span>
                <span className="ubs-info-value">
                  {clickedAction?.assessment_id?.totalDuration ?? 0} mins
                </span>
              </div>
            </div>

            {/* Student info + attempts */}
            <div className="ubs-section white">
              <div className="ubs-student-head">
                <h4 className="ubs-student-name">
                  {clickedAction?.student_id?.name || "Student"}
                </h4>
                <div className="ubs-chips">
                  <span className="ubs-chip red">
                    {clickedAction?.currentStatus || "Blocked"}
                  </span>
                  {clickedAction?.unblockCount > 0 && (
                    <span className="ubs-chip amber">
                      Unblocked {clickedAction.unblockCount}×
                    </span>
                  )}
                </div>
              </div>

              <p className="ubs-section-title">Attempt History</p>

              {clickedAction?.startTime?.length > 0 ? (
                <table className="ubs-attempt-table">
                  <thead>
                    <tr>
                      <th style={{ width: 40 }}>#</th>
                      <th>Start</th>
                      <th>End</th>
                      <th style={{ textAlign: "right" }}>Spent</th>
                    </tr>
                  </thead>
                  <tbody>
                    {clickedAction.startTime.map((time, index) => (
                      <tr key={index}>
                        <td>
                          <span className="ubs-badge">{index + 1}</span>
                        </td>
                        <td>{convertTime(time)}</td>
                        <td>{convertTime(clickedAction?.endTime[index])}</td>
                        <td style={{ textAlign: "right", fontWeight: 600 }}>
                          {calculateTimeDifference(
                            clickedAction?.startTime[index],
                            clickedAction?.endTime[index],
                          )}{" "}
                          m
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="ubs-empty">No attempts recorded</div>
              )}
            </div>

            {/* Reset form */}
            <div className="ubs-section blue">
              <p className="ubs-section-title">Reset Attempt</p>

              <div className="ubs-form-row">
                <div className="ubs-field">
                  <label className="ubs-label">Reset Duration (mins)</label>
                  <div className="ubs-input-wrap">
                    <input
                      type="number"
                      className="ubs-input"
                      value={duration}
                      max={clickedAction?.assessment_id?.totalDuration}
                      onChange={(e) => {
                        const value = Number(e.target.value);
                        let value1 = Number(
                          clickedAction?.assessment_id?.totalDuration,
                        );
                        if (value <= value1) {
                          setDuration(value);
                          setTotalDurationCheck(false);
                        } else {
                          setTotalDurationCheck(true);
                        }
                      }}
                    />
                    <span className="ubs-input-suffix">min</span>
                  </div>
                </div>

                <div className="ubs-field">
                  <label className="ubs-label">Revised End Time</label>
                  <input
                    type="time"
                    className="ubs-input"
                    value={endTime || ""}
                    onChange={(e) => setEndTime(e.target.value)}
                  />
                </div>
              </div>

              {toalDurationCheck && (
                <div className="ubs-warn">
                  <span>⚠</span>
                  <span>
                    Reset duration must be less than or equal to total duration.
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* FOOTER */}
          <div className="ubs-footer">
            <button
              className="ubs-btn ubs-btn-cancel"
              onClick={() => setShowUnblock(false)}
            >
              Cancel
            </button>

            <button
              className="ubs-btn ubs-btn-unblock"
              disabled={!(endTime && duration) || toalDurationCheck}
              onClick={handleAssesmentUnblock}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 9.9-1" />
              </svg>
              Unblock
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnblockScreen;
